import { render, staticRenderFns } from "./EmailChangeConfirmView.vue?vue&type=template&id=61dc86cc&scoped=true&"
import script from "./EmailChangeConfirmView.vue?vue&type=script&lang=js&"
export * from "./EmailChangeConfirmView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc86cc",
  null
  
)

export default component.exports